<template>
  <article class="profileinfo">
    <div v-if="isAdmin" class="admin require">
      <div v-if="report.state === 0">
        <span>관리자에 의해 비공개 처리 되었습니다.</span>
        &nbsp;
        <Ubutton type="text" text="<u>사유보기</u>" @click="reportProcess()"/>
        &nbsp;
        <Ubutton type="text" text="<u>수정요청</u>" @click="openPopup('CsReport', report, reportSubmit)"/>
      </div>
      <div v-else>
        <span>관리자에게 수정 요청을 보냈습니다.</span>
      </div>
    </div>
    <span v-else class="view">다른 사용자에게 보여지는 내 정보</span>
    <div class="info">
      <div class="profileImg">
        <Profile class="img" size="x-big" :src="profileSrc"/>
        <div class="confirmButton">
          <Ubutton size="small" text="삭제" state="deactive" @click.native="removeProfile"/>
          <Ubutton size="small" text="등록" state="deactive" @click.native="loader.open('profile')"/>
        </div>
      </div>
      <div class="nic">
        <span v-if="!isNicEdit">{{ nic }}</span>
        <UInput v-else id="nicedit" type="text" placeholder="" v-model="nic" align="center"/>
        <Ubutton v-if="!isNicEdit" size="small" text="닉네임 수정하기" state="deactive" @click.native="nicEdit"/>
        <div v-else class="confirmButton">
          <Ubutton size="small" text="취소" state="deactive" @click.native="nicEditCancel"/>
          <Ubutton size="small" text="확인" state="deactive" @click.native="nicEdit"/>
        </div>
      </div>
    </div>
    <div class="about">
      <span class="line"></span>
      <span v-if="!isAboutEdit" v-html="getAbout"></span>
      <UInput v-else id="aboutedit" type="textarea" placeholder="다른 사용자에게 보여지는 내 소개를 작성 해보세요" v-model="about" :auto="true"/>
      <Ubutton v-if="!isAboutEdit" size="small" text="소개 수정하기" state="deactive" @click.native="aboutEdit"/>
      <div v-else class="confirmButton">
        <Ubutton size="small" text="취소" state="deactive" @click.native="aboutEditCancel"/>
        <Ubutton size="small" text="확인" state="deactive" @click.native="aboutEdit"/>
      </div>
    </div>
  </article>
</template>

<script>
import UInput from '@/components/base/UInput.vue'
import UImageLoader from '@/components/js/UImageLoader.js'
import {State} from '@/components/js/Utils'

var loader = new UImageLoader()
loader.size = 512

export default {
  props: {
  },
  created () {
    this.$http.post('/api/user/profile', {id: this.$store.getters.id}).then((e) => {
      console.log(e)
      if (e.success) {
        this.profileSrc = e.Profile
        this.prevNic = this.nic = e.Nic
        this.prevAbout = this.about = e.About
        this.state = e.State
        this.report = e.Report
        this.setPageLoading(false)
        this.$emit('loading', false)
      } else {
      }
    })
  },
  mounted () {
    loader.addForm(document.querySelector('.profileinfo'), 'profile', (id, e) => {
      var form = new FormData()
      form.append('profile', UImageLoader.dataURLToBlob(e))
      this.$http.post('/api/user/changeProfile', form, {headers: {'Content-Type': 'multipart/form-data'}}).then((e) => {
        console.log(e)
        if (e.success) {
          this.profileSrc = e.data
          this.$store.commit('profile', this.profileSrc)
        } else {
        }
      })
      // this.img = e
    })
  },
  data () {
    return {
      loader: loader,
      profileSrc: '',
      nic: '',
      prevNic: '',
      isNicEdit: false,
      about: '',
      prevAbout: '',
      isAboutEdit: false,
      state: 0,
      report: null
    }
  },
  name: 'ProfileInfo',
  computed: {
    getAbout () {
      if (this.about !== '' && this.about !== undefined) {
        return this.about.replace(/(?:\r\n|\r|\n)/g, '<br />')
      } else {
        return '다른 사용자에게 보여지는 내 소개를 작성 해보세요'
      }
    },
    isAdmin () {
      return this.state & State.ADMIN
    }
  },
  methods: {
    removeProfile () {
      var form = new FormData()
      form.append('profile', true)
      this.$http.post('/api/user/changeProfile', form, {headers: {'Content-Type': 'multipart/form-data'}}).then((e) => {
        console.log(e)
        if (e.success) {
          this.profileSrc = e.data
          this.$store.commit('profile', this.profileSrc)
        } else {
        }
      })
    },
    nicEditCancel () {
      this.isNicEdit = false
      this.nic = this.prevNic
    },
    nicEdit () {
      if (this.isNicEdit) {
        this.$http.post('/api/user/changeNic', {nic: this.nic}).then(e => {
          console.log(e)
          this.isNicEdit = false
          if (e.success) {
            this.prevNic = this.nic
            this.$store.commit('nic', this.nic)
          } else {
            this.alert('<span class="require">이미 사용중인 닉네임 입니다.</span><br /><br />' +
            '<span class="description">문의사항이 있으시면 아래 이메일로 문의 바랍니다.</span><br />' +
            '<span  class="description">support@tmeka.com</span>', '107', true)
            this.nic = this.prevNic
          }
        })
      } else {
        this.isNicEdit = true
        setTimeout(() => {
          document.querySelector('#nicedit input').focus()
        })
      }
    },
    aboutEditCancel () {
      this.isAboutEdit = false
      this.about = this.prevAbout
    },
    aboutEdit () {
      if (this.isAboutEdit) {
        this.$http.post('/api/user/changeAbout', {about: this.about}).then(e => {
          console.log(e)
          if (e.success) {
            this.prevAbout = this.about
            this.isAboutEdit = false
          } else {
          }
        })
      } else {
        this.isAboutEdit = true
        setTimeout(() => {
          document.querySelector('#aboutedit textarea').focus()
        })
      }
    },
    reportProcess () {
      this.alert({title: '비공개 사유', message: '<b>' + this.report.adminComment + '</b>', description: '해당사유에 대한 내용을 수정하신 후 <br />[수정요청]을 해주세요', require: true})
    },
    reportSubmit (e) {
      if (e.result) {
        this.report.state = 1
      }
    }
  },
  components: {
    UInput
  }
}
</script>

<style scoped>
.profileinfo {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 40px;
}
.info {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 200px;
}
.info > div {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  width: 100%;
}
.profileinfo a {
  margin-top: 20px;
}
.profileinfo .view {
  color: var(--text-base);
}
.profileImg .img{
  margin: 10px 0px;
}
.nic {
  font-size: 2em;
}
.nic span {
  margin-bottom: 10px;
}
.nic .input {
  margin-bottom: 15px;
}
.about {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 600px;
  text-align: left;
  color: var(--text-base);
  margin-top: 10px;
}
.about .line {
  margin: 20px 0px;
  border-top: 1px solid var(--line-base);
}
.about .input, .about span {
  width: 100%;
  margin-bottom: 10px;
}
.about > button {
  margin-top: 10px;
  width: 200px;
}
.confirmButton {
  display: flex;
  width: 200px;
}
.confirmButton button {
  flex: 1;
}
.confirmButton button:first-child {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/router/page/myinfo/profileinfo.vue